<template>
  <div class="c-container js-container">
    <div
      class="u-container"
      @click="clickListener"
    >
      <div class="c-container__inner">
        <progressBar :step="10" />
        <!-- Begin content -->
        <h1 class="c-container__title">
          {{ title }}
        </h1>
        <section
          v-for="(component, index) in json.components"
          :key="index"
          :class="component.type.toLowerCase()"
        >
          <div
            v-if="component.type === 'chart'"
            class="c-container__charts-component"
          >
            <div class="c-container__charts">
              <div class="c-container__chart">
                <h2 class="c-container__chart-title"><span class="c-container__country-name">{{ country }}</span> Proliferation Financing Risk Heatmap: Generated by You</h2>
                <chart
                  :threat-numbers="threatNumbers"
                  :component="component"
                  :clicked-outside="clickedOutside"
                  :lightbox-click="lightboxClick"
                  :active-chart="activeChart"
                  type="dynamic"
                  @resetClickedOutside="clickedOutside = false"
                  @resetLightboxClick="lightboxClick = true"
                  @setActiveChart="activeChart = $event"
                />
              </div>
              <div class="c-container__chart">
                <h2 class="c-container__chart-title">
                  <span class="c-container__country-name">{{ country }}</span> Proliferation Financing Risk Heatmap: Generated by RUSI
                </h2>
                <chart
                  :threat-numbers="threatNumbers"
                  :component="component"
                  :clicked-outside="clickedOutside"
                  :lightbox-click="lightboxClick"
                  :active-chart="activeChart"
                  type="static"
                  @resetClickedOutside="clickedOutside = false"
                  @resetLightboxClick="lightboxClick = true"
                  @setActiveChart="activeChart = $event"
                />
              </div>
            </div>
            <div class="c-container__heat-legend">
              <span class="c-container__heat-title">Risk</span>
              <span class="c-container__heat-graph"></span>
              <ul class="c-container__heat-list">
                <li>Low</li>
                <li>Medium</li>
                <li>High</li>
              </ul>
            </div>
            <p class="c-container__chart-caption">
              *The likelihood rating for each threat was calculated as the average of the threat and vulnerability ratings assigned to that threat.
            </p>
          </div>
          <div
            v-if="component.type !== 'chart' && component.type !== 'buttons'"
          >
            <component
              :is="component.type"
              :component="component"
              :country="country"
            />
          </div>
          <!-- Previous Next buttons -->
          <div
            v-if="component.type === 'buttons'"
            class="c-container__button-container"
          >
            <button
              class="c-container__button c-container__button--prev"
              type="submit"
              @click.prevent="onSubmitPrevious"
            >
              Previous
            </button>
            <!-- Start again, reset the state. -->
            <a
              class="c-container__button c-container__button--next"
              @click.prevent="startOver"
              @keyup.prevent="startOver"
            >
              Start over
            </a>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import 'element-closest-polyfill';

// Pym.js embed.
import pymChild from '../embed/index';

import ContentComponent from '../components/ContentComponent.vue';
import Chart from '../components/Chart.vue';
import ProgressBar from '../components/ProgressBar.vue';

// Import the json for this component.
const jsonConfig = require('../assets/content/results.json');

export default {
  components: {
    contentComponent: ContentComponent,
    chart: Chart,
    progressBar: ProgressBar,
  },
  data() {
    return {

      // The JSON file as a JS array.
      json: jsonConfig,
      clickedOutside: false,
      lightboxClick: false,
      activeChart: '',
    };
  },
  computed: {
    ...mapGetters([
      'step',
      'country',
      'severities',
    ]),
    title: {
      get() {
        let countryCapitalised = this.$store.getters.country.charAt(0).toUpperCase();
        countryCapitalised += this.$store.getters.country.slice(1);
        return this.json.title.replace('[COUNTRY]', countryCapitalised);
      },
    },
    threatNumbers: {
      get() {
        const threatNumbers = [];
        // eslint-disable-next-line no-restricted-syntax
        Object.keys(this.$store.state.severities).forEach((property, index) => {
          if (typeof property === 'string') {
            const number = property.replace(/^\D+/g, '');
            if (threatNumbers.indexOf(number) === -1) {
              threatNumbers.push(number);
            }
          }
        });
        return threatNumbers;
      },
    },
  },
  methods: {
    onSubmitPrevious() {
      const previousStep = this.step;
      if (previousStep > 0) {
        this.$store.commit('setStep', previousStep);
        this.$router.push(`/country/${this.$store.getters.country}/${previousStep}`);
      } else {
        this.$router.push('/country-selection');
      }
      this.scrollToTop();
    },
    startOver() {
      this.$store.dispatch('resetState');
      this.$router.push('/');
      this.scrollToTop();
    },
    clickListener() {
      const parentThis = this;
      document.body.addEventListener('click', (event) => {
        if (event.target.closest('.js-lightbox') !== null || event.target.closest('.c-chart__hover-box') !== null) {
          parentThis.lightboxClick = false;
        } else {
          parentThis.lightboxClick = true;
          document.querySelector('body').classList.remove('is-scroll-locked');
        }
        if (event.target.closest('.c-chart__icon-group') !== null) {
          parentThis.clickedOutside = false;
        } else {
          parentThis.clickedOutside = true;
        }
      });
    },
    hasSomeParentTheClass(element, classname) {
      if (typeof element.className === 'string' && element.className.indexOf(classname) !== -1) {
        return true;
      }
      return element.parentNode && this.hasSomeParentTheClass(element.parentNode, classname);
    },
    scrollToTop() {
      document.getElementsByClassName('js-container')[0].scrollIntoView();
      pymChild.scrollParentToChildPos(-72);
    },
  },
  mounted: () => {
    pymChild.sendHeight();
  },
  updated: () => {
    pymChild.sendHeight();
  },
};
</script>
